module.exports = __webpack_public_path__ + "static/02-05215fe774da093eb915603c3b74dab2.jpg";